import { graphql } from 'gql/generated'

export const CHANGE_FRAGMENT = graphql(`
  fragment ChangeFragment on Change {
    id
    status
    type
    statusChanges {
      status
      changedAt
    }
    user {
      id
      username
      firstName
      lastName
    }
    bookings {
      id
    }
    trips {
      id
      departureAt
    }
    difference {
      routeService {
        id
        code
      }
      vehicle {
        old {
          id
          name
          partner {
            name
            externalID
          }
          capacity
        }
        new {
          id
          name
          partner {
            name
            externalID
          }
          capacity
        }
      }
      segments {
        old {
          id
          origin {
            id
            name
            code
            timezone
          }
          destination {
            id
            name
            code
            timezone
          }
        }
        new {
          id
          origin {
            id
            name
            code
            timezone
          }
          destination {
            id
            name
            code
            timezone
          }
        }
      }
      itinerary {
        old {
          origin {
            id
            name
            code
            timezone
          }
          departureAt
          arrivalAt
        }
        new {
          origin {
            id
            name
            code
            timezone
          }
          departureAt
          arrivalAt
        }
      }
    }
  }
`)

export const GET_EXECUTED_CHANGES = graphql(`
  query GetExecutedChanges($pagination: Pagination, $input: changesQueryInput) {
    changes(pagination: $pagination, input: $input) {
      total
      items {
        ...ChangeFragment
        movedBookings {
          id
        }
      }
    }
  }
`)

export const GET_SCHEDULED_CHANGES = graphql(`
  query GetScheduledChanges($pagination: Pagination, $input: changesQueryInput) {
    changes(pagination: $pagination, input: $input) {
      total
      items {
        ...ChangeFragment
        executeAt
      }
    }
  }
`)
